import {
  Box,
  Tab,
} from "@mui/material";

export default function CustomTab({
  label,
  count,
  textBackground,
  textColorOption,
  ...props
}) {
  return (
    <Tab
      label={
        <Box display="flex" alignItems="center" fontSize={props.fontSize}>
          <span>{label}</span>
          <Box
            component="span"
            ml={1}
            bgcolor={textBackground}
            color={textColorOption}
            borderRadius="6px"
            minWidth="24px"
            height="22px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            px={0.75}
            fontWeight={700}
            fontSize={props.fontSize ?? 12}
          >
            {count}
          </Box>
        </Box>
      }
      {...props}
    />
  );
}
